import React from 'react';

const Services = () => {
    const services = [
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
            ),
            title: "Düğün Davetiyeleri",
            description: "Hayatınızın en özel günü için romantik ve zarif dijital davetiyeler. Kişiselleştirilebilir temalar ve müzik seçenekleri.",
            features: ["Özel temalar", "Müzik ekleme", "Fotoğraf galerisi", "Konum bilgisi"]
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                </svg>
            ),
            title: "Doğum Günü Kutlamaları",
            description: "Yaşa uygun renkli ve eğlenceli tasarımlar. Çocuk ve yetişkin doğum günleri için özel şablonlar.",
            features: ["Yaşa özel tasarım", "Animasyonlu efektler", "Fotoğraf galerisi", "Konum bilgisi",]
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {/* Kadın figürü */}
                    <circle cx="8" cy="4" r="2" strokeWidth={1.5} />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 8v8m-2 4h4m-2-4v4" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 12l4 0" />
                    {/* Erkek figürü */}
                    <circle cx="16" cy="4" r="2" strokeWidth={1.5} />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 8v12m-2-8h4m-4 4l2 2m2-2l-2 2" />
                    {/* Kalp */}
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 10c0-1 1-2 2-2s2 1 2 2c0 1-2 3-2 3s-2-2-2-3z" />
                </svg>
            ),
            title: "Nişan Törenleri",
            description: "Sade ve şık tasarımlar ile nişan töreninizi duyurun. Aile ve arkadaşlarınızla bu mutluluğu paylaşın.",
            features: ["Şık tasarımlar", "Aile bilgileri", "Konum Bilgisi", "Program detayları", "Müzik ekleme"]
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="6" cy="6" r="2" fill="currentColor" />
                    <circle cx="18" cy="6" r="2" fill="currentColor" />
                    <circle cx="12" cy="10" r="2" fill="currentColor" />
                    <circle cx="8" cy="16" r="2" fill="currentColor" />
                    <circle cx="16" cy="16" r="2" fill="currentColor" />
                    <circle cx="4" cy="20" r="1" fill="currentColor" />
                    <circle cx="20" cy="20" r="1" fill="currentColor" />
                    <circle cx="12" cy="20" r="1" fill="currentColor" />
                </svg>
            ),
            title: "Kına Geceleri",
            description: "Geleneksel ve modern kına gecesi davetiyeleriniz için özel tasarımlar. Renkli ve neşeli temalar.",
            features: ["Geleneksel motifler", "Renkli tasarımlar", "Müzik listesi", "Konum bilgisi"]
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            ),
            title: "Kurumsal Etkinlikler",
            description: "İş dünyası için profesyonel etkinlik davetiyeleri. Konferans, seminer ve toplantılar için ideal.",
            features: ["Profesyonel tasarım", "Logo entegrasyonu", "Program detayları", "Konum bilgisi"]
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" strokeWidth={2} />
                    <circle cx="9" cy="9" r="1.5" fill="currentColor" />
                    <circle cx="15" cy="9" r="1.5" fill="currentColor" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 15s1.5 2 4 2 4-2 4-2" />
                </svg>
            ),
            title: "Özel Günler",
            description: "Mezuniyet, sünnet gibi özel günleriniz için anlamlı davetiyeler hazırlayın.",
            features: ["Özel mesajlar", "Anı paylaşımı", "Tebrik kartları", "Fotoğraf galerisi"]
        }
    ];

    return (
        <section id="hizmetlerimiz" className="relative py-20 lg:py-28 bg-gradient-to-b from-primary-50 via-white to-dark-50 overflow-hidden">
            {/* Arka plan dekoratif elementler */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-20 right-10 w-40 h-40 bg-primary-100 rounded-full opacity-10 animate-float"></div>
                <div className="absolute bottom-32 left-5 w-32 h-32 bg-dark-100 rounded-full opacity-15 animate-pulse-slow"></div>
                <div className="absolute top-1/3 left-1/3 w-20 h-20 bg-primary-200 rounded-full opacity-20 animate-bounce-slow"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Başlık bölümü */}
                <div className="text-center mb-16 animate-fade-in">
                    <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                        💼 Hizmetlerimiz
                    </div>
                    <h2 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-6 animate-slide-up">
                        Her Özel An İçin
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 block pt-2 pb-4 mb-2 leading-relaxed">
                            Profesyonel Çözümler
                        </span>
                    </h2>
                    <p className="text-lg text-dark-600 max-w-3xl mx-auto leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        Hayatınızın her özel anı için özenle tasarlanmış dijital davetiye çözümleri sunuyoruz.
                        Modern teknoloji ile geleneksel zarafeti buluşturarak unutulmaz anılar yaratmanıza yardımcı oluyoruz.
                    </p>
                </div>

                {/* Hizmetler grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-primary-200 transform hover:-translate-y-2 animate-slide-up"
                            style={{ animationDelay: `${0.1 * index}s` }}
                        >
                            {/* İkon */}
                            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-2xl mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 mx-auto">
                                {service.icon}
                            </div>

                            {/* Başlık */}
                            <h3 className="text-xl font-bold text-dark-900 mb-4 group-hover:text-primary-700 transition-colors text-center">
                                {service.title}
                            </h3>

                            {/* Açıklama */}
                            <p className="text-dark-600 mb-6 leading-relaxed text-center">
                                {service.description}
                            </p>

                            {/* Özellikler */}
                            <div className="space-y-2">
                                {service.features.map((feature, featureIndex) => (
                                    <div key={featureIndex} className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full flex-shrink-0"></div>
                                        <span className="text-sm text-dark-600 font-medium">{feature}</span>
                                    </div>
                                ))}
                            </div>


                        </div>
                    ))}
                </div>

                {/* Alt CTA bölümü */}
                <div className="text-center mt-16 animate-slide-up" style={{ animationDelay: '0.8s' }}>
                    <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-3xl p-8 lg:p-12 shadow-2xl text-white relative overflow-hidden">
                        {/* Arka plan pattern */}
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -translate-y-8 translate-x-8"></div>
                            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full translate-y-6 -translate-x-6"></div>
                        </div>

                        <div className="relative">
                            <h3 className="text-2xl lg:text-3xl font-bold mb-4">
                                Özel Davetleriniz İçin Dijital Davetiyeler
                            </h3>
                            <p className="text-primary-100 mb-8 max-w-2xl mx-auto">
                                Yukarıdaki hizmetler dışında özel bir ihtiyacınız var mı? Uzman ekibimiz size özel çözümler geliştirebilir.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">

                                <button
                                    onClick={() => {
                                        const element = document.getElementById('iletisim');
                                        if (element) {
                                            element.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    className="border-2 border-white text-white px-8 py-4 rounded-xl hover:bg-white hover:text-primary-700 transition-all duration-300 font-semibold">
                                    İletişime Geç
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services; 